import React from "react";
import { TextField, Button, Grid, Typography, Autocomplete } from "@mui/material";
import ModalLayout from "components/ModalLayout";
import MDButton from "components/MDButton";
import CancelButton from "components/CancelButton";

function CategoryFormModal({
  open,
  handleClose,
  categoryData,
  handleInputChange,
  handleFileChange,
  handleSubmit,
  isEditing,
  agreements,
}) {
  const selectedAgreement = agreements?.find(a => a.id === categoryData.agreement_template_id) || null;
  return (
    <ModalLayout
      open={open}
      onClose={handleClose}
      title={isEditing ? "Edit Category" : "Add Category"}
      subtitle="Category"
      maxWidth={900}
      headerContent={
        <Typography variant="body2" color="text.secondary" mt={1}>
          Provide multilingual content, choose a highlight color, and upload a brand asset.
        </Typography>
      }
      contentSx={{
        overflowY: "auto",
        maxHeight: "calc(90vh - 180px)",
      }}
      actions={
        <>
          <CancelButton onClick={handleClose} />
          <MDButton
            type="submit"
            form="category-form"
            variant="gradient"
            color="info"
            sx={{ minWidth: 140 }}
          >
            {isEditing ? "Update" : "Add"}
          </MDButton>
        </>
      }
    >
      <form id="category-form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>


          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title (EN)"
              name="name_en"
              value={categoryData.name_en}
              onChange={handleInputChange}
              margin="normal"
              required
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title (FR)"
              name="name_fr"
              value={categoryData.name_fr}
              onChange={handleInputChange}
              margin="normal"
              required
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Description (EN)"
              name="description_en"
              value={categoryData.description_en}
              onChange={handleInputChange}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Description (FR)"
              name="description_fr"
              value={categoryData.description_fr}
              onChange={handleInputChange}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>

          {/* Business Type Section (6/12) */}
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={["individual", "business", "both"]}
              value={categoryData.business_type || null}
              onChange={(event, newValue) => {
                handleInputChange({ target: { name: "business_type", value: newValue } });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Business Type"
                  fullWidth
                  InputProps={{ ...params.InputProps, sx: { borderRadius: 2 } }}
                />
              )}
            />
          </Grid>

          {/* Agreement Section (6/12) */}
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={agreements || []}
              getOptionLabel={(option) => option.name || ""}
              value={selectedAgreement}
              onChange={(event, newValue) => {
                handleInputChange({
                  target: { name: "agreement_template_id", value: newValue ? newValue.id : "" }
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Agreement"
                  fullWidth
                  InputProps={{ ...params.InputProps, sx: { borderRadius: 2 } }}
                />
              )}
            />
          </Grid>


          {/* Color Picker Section (3/12) */}
          <Grid item xs={12} sm={3}>
            <div style={{ position: "relative", marginTop: 8 }}>
              <input
                type="color"
                id="color-input"
                name="color"
                value={categoryData.color}
                onChange={handleInputChange}
                style={{
                  position: "absolute",
                  opacity: 0,
                  width: "100%",
                  height: "40px",
                  cursor: "pointer",
                  padding: 0,
                  border: "none"
                }}
              />
              <label
                htmlFor="color-input"
                style={{
                  display: "block",
                  width: "100%",
                  height: "40px",
                  borderRadius: "8px",
                  backgroundColor: categoryData.color || "#000000",
                  border: "1px solid #e2e8f0",
                  cursor: "pointer",
                  margin: 0
                }}
              />
              <Typography variant="caption" sx={{ position: "absolute", top: -20, left: 4, color: "text.secondary", fontWeight: "bold" }}>
                Color
              </Typography>
            </div>
          </Grid>

          {/* Upload Image Section (3/12) */}
          <Grid item xs={12} sm={3}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 8 }}>
              <input
                type="file"
                id="file-input"
                onChange={(e) => handleFileChange(e, "image")}
                style={{ display: "none" }}
              />
              <label htmlFor="file-input" style={{ flexGrow: 1 }}>
                <Button variant="outlined" component="span" sx={{ width: "100%", color: "gray" }}>
                  Upload
                </Button>
              </label>
              {categoryData.image_preview && (
                <img
                  src={categoryData.image_preview}
                  alt="Preview"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                    objectFit: "cover"
                  }}
                />
              )}
            </div>
          </Grid>

        </Grid>
      </form>
    </ModalLayout>
  );
}

export default CategoryFormModal;
